import { Component, OnInit } from '@angular/core';
import { PessoaFisicaSexoLabels } from '@tivic-team/manager-ts/dist/grl/enums/pessoa-fisica-sexo.enum';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
@Component({
  selector: 'dropdown-sexo',
  templateUrl: './dropdown-sexo.component.html',
  styleUrls: ['./dropdown-sexo.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownSexoComponent implements OnInit {

  tipoSexo

  constructor() { }

  ngOnInit() {
    this.tipoSexo = PessoaFisicaSexoLabels;
  }

}
